import { ageOn, type PDate } from "@/plan-logic/lib/dates";

/**
 * "Years in Canada since 18" (`persons[].oas_residency.years_in_canada_after_18`): the years so far,
 * which the engine projects to OAS start itself (ee472c058). Sharpen and Update Data ask it with the
 * same hint (copy `fields.yearsInCanadaHint`) and the same check. Blank is allowed and stays unset
 * (the engine assumes a full lifetime in Canada).
 */

/** The most it can be: the whole years since the 18th birthday (100 when the birthday is unknown). */
export function maxYearsInCanada(dob: PDate | undefined, today: PDate): number {
  const age = ageOn(dob, today);
  return age === undefined ? 100 : Math.max(0, age - 18);
}

/** Why a value can't be saved, or undefined (blank included). */
export function yearsInCanadaIssue(
  value: number | undefined,
  dob: PDate | undefined,
  today: PDate,
): string | undefined {
  if (value === undefined) return undefined;
  const max = maxYearsInCanada(dob, today);
  if (!Number.isInteger(value) || value < 0 || value > max) {
    return `Enter whole years, from 0 to ${max} (the years since turning 18).`;
  }
  return undefined;
}
